export const CLASS_MODAL_PAGE = 'modal-page';
